import { GlSprintf } from '@gitlab/ui';
import { s__ } from '~/locale';
import DetailsRow from '~/vue_shared/components/registry/details_row.vue';
export default {
    name: 'MetadataPypi',
    i18n: {
        requiredPython: s__('PackageRegistry|Required Python: %{pythonVersion}'),
        summary: s__('PackageRegistry|Summary: %{summary}'),
        authorEmail: s__('PackageRegistry|Author email: %{authorEmail}'),
        keywords: s__('PackageRegistry|Keywords: %{keywords}')
    },
    components: {
        DetailsRow,
        GlSprintf
    },
    props: {
        packageMetadata: {
            type: Object,
            required: true
        }
    }
};
